import * as React from "react";

function getCurrentMarkerScale() {
  if (typeof window === "undefined") return 1;

  const dpr = window.devicePixelRatio || 1;

  return Math.min(1, 1 / dpr);
}

export function useMapMarkerScale() {
  const [scale, setScale] = React.useState(getCurrentMarkerScale);

  React.useEffect(() => {
    const update = () => {
      setScale(getCurrentMarkerScale());
    };

    window.addEventListener("resize", update);

    const mediaQueries = [
      window.matchMedia("(resolution: 1dppx)"),
      window.matchMedia("(resolution: 1.25dppx)"),
      window.matchMedia("(resolution: 1.5dppx)"),
      window.matchMedia("(resolution: 1.75dppx)"),
      window.matchMedia("(resolution: 2dppx)"),
      window.matchMedia("(resolution: 2.5dppx)"),
      window.matchMedia("(resolution: 3dppx)"),
    ];

    mediaQueries.forEach((mq) => {
      mq.addEventListener("change", update);
    });

    update();

    return () => {
      window.removeEventListener("resize", update);

      mediaQueries.forEach((mq) => {
        mq.removeEventListener("change", update);
      });
    };
  }, []);

  return scale;
}
